var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_25830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.33331L13.1667 2.66665M13.1667 2.66665L15.1667 4.66665L12.8333 6.99998L10.8333 4.99998M13.1667 2.66665L10.8333 4.99998M8.09333 7.73998C8.43756 8.07962 8.7112 8.48401 8.8985 8.92984C9.0858 9.37568 9.18306 9.85416 9.18468 10.3377C9.18631 10.8213 9.09225 11.3004 8.90794 11.7475C8.72363 12.1946 8.45271 12.6008 8.11076 12.9427C7.76882 13.2847 7.36261 13.5556 6.91554 13.7399C6.46846 13.9242 5.98933 14.0183 5.50575 14.0167C5.02218 14.015 4.5437 13.9178 4.09786 13.7305C3.65203 13.5432 3.24764 13.2695 2.908 12.9253C2.24009 12.2338 1.87051 11.3076 1.87886 10.3462C1.88722 9.38479 2.27284 8.46514 2.95267 7.78531C3.63249 7.10548 4.55214 6.71986 5.51353 6.71151C6.47492 6.70315 7.40113 7.07273 8.09267 7.74065L8.09333 7.73998ZM8.09333 7.73998L10.8333 4.99998",
    stroke: "#0F131E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_25830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.782003ddc65c45bd54cb35feeee234a2.svg";
export { ForwardRef as ReactComponent };